<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div>
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Job Sheet - Print Edition| O2Care - Oxygen Digital Shop</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
			  <button class="btn btn-secondary align-right" align="right" onClick="window.print()"><i class="fa fa-cog"></i>Print Job Sheet</button>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>


    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-sm-12" id="print">


		<div class="col-sm-12">
			<div class="col-sm-4">
				<LogoPrint></LogoPrint>
			</div>
		</div>
		<br>
		<br>

			<div class="col-sm-12">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-body overflow-auto border-none">
								<div class="row">
									<div class="col-sm-8">
										Job Category:</b><h5> {{job.job_category}}</h5>
							<br><b>Job No: </b><h5>{{job.job_no}}</h5>
							<br>Last Status Update On: {{job.updated_at | timeStamp}}
						<br>Last Status Update By: {{job.updated_name}}
									</div>
									<div class="col-sm-4 float-right">
										<h1>{{job.branch}}</h1>
										{{job.branch_name}}
										<br>
										GST: &nbsp; {{job.branch_gst}}
										<br>
										Phone: &nbsp; {{job.branch_number}}
										<br>
										<b>Amount Collected:</b>
										<h5>{{job.amount_collected}}</h5>
                                            <b>Estimated Total:</b>
                                            <h5>{{ job.estimated_cost }}</h5>
                                        </div>
									</div>
								</div>

						</div>
						</div>

					</div>


				<div class="row">
					<div class="col-sm-6">
							<div class="card card-danger card-outline">
		<div class="card-header">
			<h5>Customer:</h5> ID:{{job.customer_id}}
		</div>
		<div class="card-body overflow-auto">
			<b>Name:</b><h5>{{job.customer_name}}</h5>
			<br><b>Phone:</b><h5>{{job.customer_numbers}}</h5>
			<br><b>Communication Address:</b><h5>{{job.bill}}</h5>
			<br><b>Billing Address:</b><h5>{{job.comm}}</h5>

		</div>
							</div>
						</div>

						<div class="col-sm-6">
						<div class="card card-danger card-outline">
						<div class="card-header">
			<h5>Item Details:</h5>
		</div>
		<div class="card-body overflow-auto">

						Item Code: {{job.item_code}}
						<br>Item Name: {{job.item_name}}
						<br>Item Code: {{job.item_code}}
						<br>Brand: {{job.brand}}
						<br>Category: {{job.category}}
						<br>Model: {{job.model}}
						<br>Bill Number: {{job.bill_number}}
						<br>Serial No: {{job.sl_no}}

						<br>Bought from Oxygen: {{job.oxygen_bought}}
						<br>Purchased From: {{job.purchased_from}}
						<br>Year of Purchase: {{job.purchased_year | formattedDateWithOne}}
						<br>
						<br>Description: {{job.description}}
						<br>Status: {{job.status}}
						<br>Type: {{job.type}}
						</div>
					</div>
					</div>


				</div>
				<br>
				<br>

				<div class="row">
						<div class="col-sm-12">
							<div class="row">
								<div class="col-sm-6">
									<div class="col-sm-12">
										<p>______________________</p>
									</div>
									<div class="col-sm-12">
										<p>Customer Signature</p>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="col-sm-12">
										<p>______________________</p>
									</div>
									<div class="col-sm-12">
										<p>Service Associate Signature</p>
									</div>
								</div>
							</div>
					</div>
				</div>

				<div class="row">

					<div class="col-sm-6">
						<div class="card card-danger card-outline">
						<div class="card-header">
			<h5>Item Details:</h5>
		</div>
		<div class="card-body overflow-auto">
						Job Assigned To: {{job.assigned_name}}
						<br>Complaint: {{job.complaint}}
						<br>Job Added on: {{job.created_at | timeStamp}}
						<br>Job Added By:{{job.created_name}}

						<br>Current Condition:{{job.current_condition}}
						<br>Expected Delivery Date:{{job.expected_delivery_date | formattedDateWithOne}}

						<br>Accessories Received:{{job.accessories_received}}
		</div>
		</div>
					</div>

					<div class="col-sm-6">
						<div class="card card-danger card-outline">
						<div class="card-header">
			<h5>Important Terms to note:</h5>
		</div>
		<div class="card-body overflow-auto">
						<h5>1.</h5>
						<p>Oxygen Group, nor its subsidiaries, nor its employees will be responsible for any item that isn't collected within 60 days of completion of job sheet.</p>
						<h5>2.</h5>
						<p>
							We do not provide data preservation guarantees unless specifically mentioned in the job sheet description.
						</p>
		</div>
		</div>
		</div>




		</div>

		<br>
		<br>
		<br>
		<br>
		<div class="row">

					<div class="col-sm-12">
						<div class="card card-danger card-outline">
						<div class="card-header">
			<h5>Terms and Conditions:</h5>
		</div>
		<div class="card-body overflow-auto">
			<div v-html="terms"></div>
		</div>
		</div>
					</div>
		</div>



		<br>
		<br>



	</div>







</div>


<!-- row end -->
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        </div>
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){
        	this.getJobDets();
        	this.getModes();
			this.getServiceTerms();
        },

        data(){
        	return {
        		job: [],
        		remarks: [],
        		amounts: [],
        		form: new Form({
        			job_id: '',
        			room: '',
        			shelf: '',
        			rack: '',
        			id: ''
        		}),
        		errors: [],
        		payments: [],
				terms: '',
        		amount: '',
        		modes: [],
        		mode: '',
        		premark: '',
        		transaction_id: ''
        	}
        },

        methods: {
        	getModes(){
        		axios.post("/api/getModes")
        		.then(response => {
        			this.modes = response.data;
        		})
        	},

            print(){
                const prtHtml = document.getElementById('print').innerHTML;

// Get all stylesheets HTML
                let stylesHtml = '';
                for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                    stylesHtml += node.outerHTML;
                }

// Open the print window
                const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

                WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

                WinPrint.document.close();
                WinPrint.focus();
                WinPrint.print();
                // WinPrint.close();
            },

        	getJobDets(){
        		axios.post("/api/getFullJobDetails", {id: this.$route.params.id})
        		.then(response => {
        			this.job = response.data;
        			this.getRemarks();
        			this.getAmounts();
        			this.getPayments();
        			if(this.job.status == 'Completed'){
        				this.getShelf();
        			}
        		})
        	},

        	getRemarks(){
        		axios.post("/api/getRemarks", {job: this.job.id})
        		.then(response => {
        			this.remarks = response.data;
        		})
        	},

        	getShelf(){
        		axios.post("/api/getShelf", {job: this.job.id})
        		.then(response => {
        			this.form.job_id = this.job.id;
        			if(response.data != '')
        				this.form.fill(response.data);
        		})
        	},

        	storeItem(){
        		this.form.job_id = this.job.id;
        		this.form.post("/api/storeJobItem")
        		.then(response => {
        			if(response.data == 200){
        				toast.fire({
        					icon: 'success',
        					title: 'Storage Updated'
        				})
        				this.getShelf();
        			}
        			else{
        				toast.fire({
        					icon: 'error',
        					title: 'Failed'
        				})
        			}
        		})
        		.catch(() => {
        			toast.fire({
        					icon: 'error',
        					title: 'Failed'
        				})
        		})
        	},

        	getAmounts(){
        		axios.post("/api/getAmounts", {job: this.job.id})
        		.then(response => {
        			this.amounts = response.data;
        		})
        	},

			getServiceTerms(){
    			axios.post("/api/getLatestServiceTerms")
    			.then(response => {
    			this.terms = response.data.terms;
    			})
    		},

        	getPayments(){
        		axios.post("/api/getPayments", {job: this.job.id})
        		.then(response => {
        			this.payments = response.data;
        		})
        	},

        	addPayment(){
        		axios.post("/api/addPayment", {job: this.job.id, amount: this.amount, mode:this.mode, remarks: this.premark, transaction_id: this.transaction_id})
        		.then(response => {
        			if(response.data == 200){
        				toast.fire({
        					icon: 'success',
        					title: 'Payment Added'
        				})
        				this.getJobDets();
        			}
        			else{
        				toast.fire({
        					icon: 'error',
        					title: 'Failed'
        				})
        			}
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        			toast.fire({
        					icon: 'error',
        					title: 'Failed'
        				})
        		})
        	},

			printInvoice(){
        				this.$router.push("/print/invoice/"+this.response.id);
        	},

        	deletePayment(id){
        		axios.post("/api/deletePayment", {id: id})
        		.then(response => {
        			if(response.data == 200){
        				toast.fire({
        					icon: 'success',
        					title: 'Payment Deleted'
        				})
        				this.getJobDets();
        			}
        			else{
        				toast.fire({
        					icon: 'error',
        					title: 'Failed'
        				})
        			}
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        			toast.fire({
        					icon: 'error',
        					title: 'Failed'
        				})
        		})
        	}
        }
    }
</script>
